<template>
  <div class="under-head-notification  container">
    <div class="under-head-notification__content  container-inner">
      <div class="under-head-notification__text text">
        {{ $tGlobal('You have an Interaction started.') }}
        <router-link-modified :to="{name: 'account-interaction', params: {id: openedInteractionId}}"
                              class="inline-link  _white">
          <span>{{ $tGlobal('Go to interaction') }}</span>
          <BaseSvg name="ico-arrow-light"
                   width="0.5rem"
                   height="1rem"
                   style="margin-left: 0.4rem"
                   class="_arrow"/>
        </router-link-modified>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: 'YouHaveInteractionStartedNotification',
    data() {
      return {}
    },
    computed: {
      ...mapState('user', [
        'openedInteractionId',
      ])
    }
  }
</script>

<style lang="less">

</style>
